import type { RuntimeProbeTweenSnapshot } from './runtimeProbeTypes';

export interface RuntimeProbeTweenRegistry {
  upsert(snapshot: RuntimeProbeTweenSnapshot): void;
  snapshot(): RuntimeProbeTweenSnapshot[];
  clear(): void;
}

export function createRuntimeProbeTweenRegistry(): RuntimeProbeTweenRegistry {
  const active = new Map<string, RuntimeProbeTweenSnapshot>();
  const terminalOnce = new Map<string, RuntimeProbeTweenSnapshot>();

  return {
    upsert(snapshot) {
      if (snapshot.status === 'running') {
        active.set(snapshot.id, snapshot);
        terminalOnce.delete(snapshot.id);
        return;
      }
      active.delete(snapshot.id);
      terminalOnce.set(snapshot.id, snapshot);
    },
    snapshot() {
      const output = [...active.values(), ...terminalOnce.values()];
      terminalOnce.clear();
      return output;
    },
    clear() {
      active.clear();
      terminalOnce.clear();
    },
  };
}
